import { useTranslation } from "react-i18next";

import { formatCarbon, getCarbonDisplayUnit } from "@/utils/carbon";
import { ChartCategory } from "@/utils/consolidation";

import CategoryChart from "./CategoryChart";

type ReviewByCategoriesProps = {
  categories: ChartCategory;
};

function ReviewByCategories({ categories }: ReviewByCategoriesProps) {
  const { t } = useTranslation(["formatter"]);

  const categoriesUnit = getCarbonDisplayUnit(
    categories.map((category) => category.value)
  );

  return (
    <div className="gap-sm grid grid-cols-2 items-center xl:grid-cols-3">
      {categories
        .filter((category) => category.value > 0.0)
        .map((category) => {
          const { formattedCarbon, unit } = formatCarbon(
            t,
            category.value,
            categoriesUnit
          );
          return (
            <CategoryChart
              key={category.name}
              data={category.children}
              title={category.name}
              carbon={category.value}
              carbonToDisplay={formattedCarbon}
              carbonUnit={unit}
            />
          );
        })}
    </div>
  );
}

export default ReviewByCategories;
